// DAY-DIRECTSTAFF-2026-10-31 §1: the job a lead came from. Home's DAY-HOME-2026-10-31 §2: a chat lead from a job page (and the
// job page's apply form) posts the posting id as raw_payload.job_id -- an id the page writes itself (data-job-ref), never PII,
// the shape the sites' source-capture allows: ^[A-Za-z0-9][A-Za-z0-9-]{0,39}$. The CRM showed only the title and location.
// The link: the job page itself when the lead's page is a /jobs/ page; otherwise the flagship's /r/<id>, which job-distribution
// sends to the posting's page (or, for a posting gone since, to the nearest landing page -- never a 404), tagged ?source=crm.
const s = (v) => (v === null || v === undefined ? '' : String(v).trim());
const raw = (l) => (l && l.raw_payload && typeof l.raw_payload === 'object' ? l.raw_payload : {});
export const JOB_ID_RE = /^[A-Za-z0-9][A-Za-z0-9-]{0,39}$/;
export const FLAGSHIP = 'https://www.protherapystaffing.com';

/** the posting id, or '' (anything not an id shape is dropped) */
export function jobIdOf(l) {
  const r = raw(l);
  const v = s(r.job_id || r.job_ref || (l && l.job_id));
  return JOB_ID_RE.test(v) ? v : '';
}
/** the job page: the lead's own page when it is a /jobs/<slug> page on our site, else /r/<id>?source=crm */
export function jobUrlOf(l, id = jobIdOf(l)) {
  if (!id) return '';
  const page = s((l && l.source_page) || raw(l).source_page);
  let u = null;
  try { u = new URL(page, FLAGSHIP); } catch (e) { u = null; }
  if (u && /^https?:$/.test(u.protocol) && /(^|\.)protherapystaffing\.com$/.test(u.hostname) && /^\/jobs\/[a-z0-9-]+\/?$/i.test(u.pathname)) {
    return `${FLAGSHIP}${u.pathname}`;
  }
  return `${FLAGSHIP}/r/${encodeURIComponent(id)}?source=crm`;
}
/** -> null | { id, url, title }  title: "PT Travel · Denver, CO" (the lead's job_title / job_location when given) */
export function jobOf(l) {
  const id = jobIdOf(l);
  if (!id) return null;
  const r = raw(l);
  return { id, url: jobUrlOf(l, id), title: [s(r.job_title), s(r.job_location)].filter(Boolean).join(' · ') };
}
